<template>
    <div class="container-fluid">
        <CRow class="pr-2">
    <CCol col="12" xl="12" class="p-0">
      <CCard>
        <CCardBody>

   <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Nastavenia > <router-link to="/taxonomy">Slovníky</router-link></h6>
                            Slovníky</span>
                            <span slot="extra">
         <router-link to="/taxonomy/add"> <a-button type="primary">Pridať slovník</a-button></router-link>
                           </span>
                        <div class="table-responsive">
                            <a-table :columns="columns" :pagination="pagination" :rowKey="record => record.id" :dataSource="data" :loading="loading" class="table-flush">
                                <template slot="name" slot-scope="user">
                                    <router-link :to="'/taxonomy/' + user.id"><a-button class="mr-2">Upraviť</a-button></router-link>
                                    <router-link :to="'/taxonomy-items/' + user.id"><a-button class="mr-2">Položky</a-button></router-link>
                                    <router-link :to="'/tree-taxonomy-items/' + user.id"><a-button class="mr-2">Preusporiadať</a-button></router-link>
                                    <a-popconfirm placement="topRight" @confirm="confirm(user.id)" @cancel="cancel" okText="Áno" cancelText="Nie">
                                        <template slot="title">
                                            <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                                            Položka bude trvalo odstránená z vašej stránky.
                                        </template>
                                        <a-button type="secondary"  icon="fas fa-trash" textColor="default" title="Zmazať">Zmazať</a-button>
                                    </a-popconfirm>
                                </template>
                            </a-table>
                        </div>
                        </a-card>
                      </CCardBody>
                            </CCard>
                            </CCol>
                            </CRow>

                    </div>

</template>
<script>
    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"

    const columns = [
       {
            title: '',
            width: '10px',
        },
        {
            title: 'Názov slovníka',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'Slug',
            dataIndex: 'slug',
        },
        {
            title: 'URL slovníka',
            dataIndex: 'url',
        },
        {
            title: 'Počet položiek',
            dataIndex: 'items',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        },
         {
            title: '',
            width: '10px',
        },
    ];

    export default {
        name: "taxonomies",
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                pagination: {
                    hideOnSinglePage: true,
                    pageSize: 150, // default number of pages per page
                    showSizeChanger: true, // display can change the number of pages per page
                    pageSizeOptions: ['10', '20', '100', '150', '300', '1000'], // number of pages per option
                    showTotal: total => `Položiek: ${total}`, // show total
                    showSizeChange: (current, pageSize) => {  this.pageSize = pageSize; }, // update display when changing the number of pages per page
                },
                columns,
            };
        },
        mounted() {
            this.fetch();
        },
        methods: {
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name).then(results => {
                    this.data = results;
                    this.loading = false;
                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
